import GlobalConfig from "./config";
import axios from 'axios';
let method = {
  // query:url上query原来的参数
  // newQuery:新加的query参数，如果没有新加的参数，传null,必须传
  NewQuery: function (query, newQuery) {
    return Object.assign({}, query, newQuery)
  },
  previewPdf: function (url) {
    let urlTemp = "/pdfShow/web/viewer.html?file=" + encodeURIComponent(url);
    window.open(urlTemp);
  },
  Ajax: function (method, url, data) {
    let newUrl = GlobalConfig.nodeIp + 'webapi' + url;
    if (method == "get") {
      axios.get(url, {
        params: data,
      }).then((res) => {
        return res;
      }).catch((err) => {
        return err;
      })
    } else if (method == "post") {
      axios.post({
        data: data,
        url: url,
        header: {
          'token': localStorage.getItem('token')
        },
        success: function (d) {
          successfn(d);
        },
        error: function (e) {
          errorfn(e);
        }
      });
    }
  }
}
export default method;